import { render, staticRenderFns } from "./ContextSwitch.vue?vue&type=template&id=db32b7ca&scoped=true"
import script from "./ContextSwitch.vue?vue&type=script&lang=js"
export * from "./ContextSwitch.vue?vue&type=script&lang=js"
import style0 from "./ContextSwitch.vue?vue&type=style&index=0&id=db32b7ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db32b7ca",
  null
  
)

export default component.exports